import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createInvitationActions } from './actions';
import { InvitationActions, InvitationState } from './types';

export const useInvitationStore = create<InvitationState & InvitationActions>()(
    immer((set, get, store) => ({
        invitations: [],
        workspaceInvitations: [],
        loading: false,
        loadingWorkspaceInvitations: false,
        selectedInvitation: null,
        loadingInvitation: false,
        error: undefined,
        invitationResolution: null,
        resolving: false,
        accepting: false,
        rejecting: false,
        ...createInvitationActions(set, get, store),
    })),
);
